<template>
  <div>
    <b-modal id="editDepartmentHodCombination" hide-footer hide-header no-close-on-backdrop no-close-on-keyboard
      no-close-on-esc size="xl" centered>
      <b-overlay :show="loadTeachers" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <div class="loading" v-if="fetchData">
          <load-data></load-data>
        </div>

        <div v-else>
          <!-- Existing Combinations -->
          <div class="existingCombinations" v-if="uniqueDepartmentHodCombinations.length != 0">
            <h5>Existing Department Hod Combinations</h5>
            <div class="courseTeachers d-flex flex-wrap">
              <p v-for="(hod, index) in uniqueDepartmentHodCombinations" :key="index"
                class="bg-info p-2 text-white rounded ml-2" style="font-size: 12px">
                {{ hod.maingroup.name + ' - ' + hod.teacher.first_name }}
                <span class="text-danger btn m-0 p-0" @click="deleteDepartmentHodDuplicationCombination(hod.id)">
                  <i class="fas fa-trash ml-2"></i>
                </span>
              </p>
            </div>
          </div>


          <!-- Reset -->
          <div class="resetTeachers text-center" v-if="maingroupHods.length != 0">
            <b-button variant="danger" @click="resetHods()" size="sm">Clear all</b-button>
          </div>

          <!-- Subgroup & HoD section -->
          <div class="d-flex mt-3" style="height: 200px">
            <div class="subgroupNames w-50" style="overflow-y: scroll">
              <b-form-checkbox v-for="(subgroup, index) in subgroupsTeachersOptions" :key="index"
                v-model="selectedMaingroupHods" :value="subgroup.value" @change="onSubgroupChange(subgroup.value)"
                size="sm">
                {{ subgroup.text }}
              </b-form-checkbox>
            </div>

            <div class="subgroupTeachers w-50" v-if="uniqueMaingroupHods.length != 0" style="overflow-y: scroll">
              <div class="users d-flex flex-wrap">
                <p v-for="(hod, index) in uniqueMaingroupHods" :key="index"
                  class="bg-success p-2 text-white rounded ml-2" style="font-size: 12px">
                  {{ hod.maingroup + ' - ' + hod.hod }}
                  <span class="text-white btn m-0 p-0" @click="removeHod(hod)">
                    <i class="far fa-times-circle ml-2"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <hr /><br />

          <!-- Submit / Cancel -->
          <div class="submitCourseTeacherCombination d-flex justify-content-between">
            <b-button variant="primary" @click="prepareSyncHodsPostData()" size="md"
              :disabled="submitBtn.disabled || selectedMaingroupHods.length == 0">
              {{ submitBtn.text }}
            </b-button>

            <b-button variant="danger" size="md" @click="cancel()" :disabled="submitBtn.disabled">
              Cancel
            </b-button>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["subgroupsForTeachers", "surveyId"],

  async created() {
    await this.resetHods();
  },

  data() {
    return {
      fetchData: false,
      loadTeachers: false,
      subgroupsTeachersOptions: this.subgroupsForTeachers,
      selectedMaingroupHods: [],
      maingroupHods: [],
      existingDepartmentHodCombinations: [],
      submitBtn: {
        text: "Submit",
        disabled: false,
      },
    };
  },

  computed: {

    uniqueDepartmentHodCombinations() {
      const unique = [];
      const seen = new Set();

      for (const item of this.existingDepartmentHodCombinations) {
        const key = `${item.maingroup_id}_${item.teacher.id}`;
        if (!seen.has(key)) {
          seen.add(key);
          unique.push(item);
        }
      }

      return unique;
    },

    // ✅ Only show unique HoD combos in frontend
    uniqueMaingroupHods() {
      const uniqueMap = new Map();
      this.maingroupHods.forEach((item) => {
        const key = `${item.maingroup_id}_${item.institution_user_id}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      });
      return Array.from(uniqueMap.values());
    },
  },

  methods: {
    async onSubgroupChange(subgroupId) {
      const isChecked = this.selectedMaingroupHods.includes(subgroupId);

      if (isChecked) {
        await this.getMaingroupHods(subgroupId);
      } else {
        // Remove existing & newly added HoDs for this subgroup
        const toDelete = this.existingDepartmentHodCombinations.filter(
          (item) => item.subgroup_id === subgroupId
        );

        for (const hod of toDelete) {
          const index = this.existingDepartmentHodCombinations.findIndex(
            (item) => item.id === hod.id
          );
          if (index !== -1) {
            await this.deleteDepartmentHodCombination(hod.id, index);
          }
        }

        this.maingroupHods = this.maingroupHods.filter(
          (item) => item.subgroup_id !== subgroupId
        );
      }
    },

    async checkDepartmentHodCombination() {
      this.$bvModal.show("editDepartmentHodCombination");
      await this.getDepartmentHodCombination();
    },

    async getDepartmentHodCombination() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey +
        `/${this.surveyId}/studfbsurveydepartmenthods`;

      await this.$axios
        .get(url)
        .then((response) => {
          this.existingDepartmentHodCombinations = response.data;
          this.selectedMaingroupHods = this.existingDepartmentHodCombinations
            .map((item) => item.subgroup_id)
            .filter((id, index, self) => id != null && self.indexOf(id) === index);
          this.fetchData = false;
        })
        .catch(() => {
          this.$toast.error("Something went wrong!", {
            position: "top",
            duration: 3000,
          });
          this.cancel();
          this.fetchData = false;
        });
    },

    async resetHods() {
      this.subgroupsTeachersOptions = this.subgroupsForTeachers;
      this.subgroupsTeachersOptions.forEach((subgroup) => (subgroup.disabled = false));
      this.selectedMaingroupHods = [];
      this.maingroupHods = [];
    },

    async getMaingroupHods(subgroupId) {
      this.loadTeachers = true;

      const selectedIndex = this.selectedMaingroupHods.findIndex(
        (val) => val === subgroupId
      );

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${subgroupId}/department/withhods`;

      try {
        const response = await this.$axios.get(url);
        const mainUsers = response.data;

        if (!mainUsers.institution_users || mainUsers.institution_users.length === 0) {
          this.$toast.warning("No HoDs found!", {
            position: "top",
            duration: 3000,
          });
          this.selectedMaingroupHods.splice(selectedIndex, 1);
        } else {
          // ✅ Allow duplicates in backend array but show unique only
          mainUsers.institution_users.forEach((hod) => {
            this.maingroupHods.push({
              maingroup: mainUsers.name,
              maingroup_id: mainUsers.id,
              hod: hod.first_name,
              institution_user_id: hod.id,
              subgroup_id: subgroupId,
            });
          });
        }
      } catch {
        this.$toast.error("Failed to load HoDs", {
          position: "top",
          duration: 3000,
        });
      }

      this.loadTeachers = false;
    },

    removeHod(hodToRemove) {
      // Remove all duplicate entries of this HoD combination
      this.maingroupHods = this.maingroupHods.filter(
        (hod) =>
          !(
            hod.maingroup_id === hodToRemove.maingroup_id &&
            hod.institution_user_id === hodToRemove.institution_user_id
          )
      );
    },

    async prepareSyncHodsPostData() {
      this.submitBtn.text = "Please wait ...";
      this.submitBtn.disabled = true;

      const syncStatus = await this.syncHodsWithFeedbackSurvey();

      if (syncStatus) {
        this.$toast.success("Linking department HoDs successfully done.", {
          position: "top",
          duration: 3000,
        });
        this.cancel();
      } else {
        this.$toast.error("Linking department HoDs failed. Please try again.", {
          position: "top",
          duration: 3000,
        });
        this.cancel();
      }
    },

    async syncHodsWithFeedbackSurvey() {
      const syncUrl = this.$store.getters.getAPIKey.studentFeedbackSurveySyncHods;
      const url = syncUrl.replace("survey_id", this.surveyId);
      let status = null;

      await this.$axios
        .post(url, { maingroup_hods: this.maingroupHods }) // ✅ All duplicates included
        .then(() => (status = true))
        .catch(() => (status = false));

      return status;
    },

    async deleteDepartmentHodCombination(hodId, index) {
      this.loadTeachers = true;
      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey +
        `/studfbsurveydepartmenthod/${hodId}`;

      await this.$axios
        .delete(url)
        .then(() => {
          this.$toast.success("Department HoD combination removed.", {
            position: "top",
            duration: 3000,
          });
          this.existingDepartmentHodCombinations.splice(index, 1);
        })
        .catch(() => {
          this.$toast.error("Something went wrong, Please try again!", {
            position: "top",
            duration: 3000,
          });
        });

      this.loadTeachers = false;
    },

    async deleteDepartmentHodDuplicationCombination(hodId) {
      this.loadTeachers = true;

      // 🔹 Find the clicked HoD combination
      // const hod = this.existingDepartmentHodCombinations[index];
      let hod = this.existingDepartmentHodCombinations.find(
        item => item.id === hodId
      );

      // 🔹 Find all duplicates with the same maingroup_id + teacher_id
      const duplicates = this.existingDepartmentHodCombinations.filter(
        (item) =>
          item.maingroup_id === hod.maingroup_id &&
          item.teacher.id === hod.teacher.id
      );


      // let hodId = 260;




      try {
        // 🔹 Delete all duplicate combinations one by one
        for (const dup of duplicates) {
          const url =
            this.$store.getters.getAPIKey.studentFeedbackSurvey +
            `/studfbsurveydepartmenthod/${dup.id}`;

          await this.$axios.delete(url);
        }

        // 🔹 Remove all from frontend list at once
        this.existingDepartmentHodCombinations = this.existingDepartmentHodCombinations.filter(
          (item) =>
            !(
              item.maingroup_id === hod.maingroup_id &&
              item.teacher.id === hod.teacher.id
            )
        );

        this.$toast.success("All matching HoD combinations removed.", {
          position: "top",
          duration: 3000,
        });
      } catch (error) {
        this.$toast.error("Something went wrong, Please try again!", {
          position: "top",
          duration: 3000,
        });
      }

      this.loadTeachers = false;
    },

    async cancel() {
      this.$bvModal.hide("editDepartmentHodCombination");
      this.submitBtn.text = "Submit";
      this.submitBtn.disabled = false;
      await this.resetHods();
    },
  },
};
</script>
